import { gql } from '@apollo/client';

export const ALL_REGISTRATION_STATUSES = gql`
  query AllRegistrationStatuses($input: InstitutionRegistrationStatusesInput) {
    registrationStatuses: getInstitutionRegistrationStatuses(input: $input) {
      id
      name
    }
  }
`;
